<template>
    <div class="py-3 intervention-plan">
        <p class="font-medium text-info text-base mb-1">{{ interventionPlan.intervention_type.name }}</p>
        <div v-for="(mths, index) in months" :key="index">
            <div class="md-layout">
                <div class="md-layout-item md-size-50 pl-0" v-for="month in mths" :key="month.id">
                    <div class="flex items-center justify-between h-full">
                        <span class="w-1/5 font-medium">{{ month.label }}</span>
                        <div class="w-full" v-if="monthHasIntervention(month.value)">
                            <div v-for="(interventionPrevision, index) in monthHasIntervention(month.value)" :key="interventionPrevision.id">
                                <div class="flex items-center justify-between">
                                    <div>
                                        <span>{{ hoursAndMinutes(interventionPrevision.duration) }}</span>
                                        <span class="px-4 leading-4">{{ interventionPrevision.commentable ? interventionPrevision.commentable.comment : '' }}</span>
                                    </div>
                                    <template v-if="interventionPrevision.device_groups.length > 0">
                                        <span class="text-info cursor-pointer" @click="openDeviceGroupsModal(interventionPrevision)">Groupements</span>
                                        <md-dialog v-if="deviceGroupsModal.data.previsionId === interventionPrevision.id"
                                                   :md-active.sync="deviceGroupsModal.active"
                                                   :md-fullscreen="false"
                                                   class="no-min-height">
                                            <md-content class="px-2 my-3.5 overflow-y-auto">
                                                <div class="px-3">
                                                    <p class="text-xl font-medium mb-2">Liste des groupements pour une prévision d'intervention</p>
                                                    <div v-for="deviceGroup in deviceGroupsModal.data.deviceGroups" :key="deviceGroup.id" class="mb-2">
                                                        <p class="text-info font-medium mb-1">{{ deviceGroup.name }}</p>
                                                        <div class="ml-4">
                                                            <template v-if="deviceGroup.devices.length > 0">
                                                                <div v-for="device in deviceGroup.devices" :key="device.id" class="flex items-center">
                                                                    <img :src="device.device_types[0].icon" alt="picto" style="max-width: 15px;" />
                                                                    <span class="ml-2 text-sm">{{ device.location }}</span>
                                                                </div>
                                                            </template>
                                                            <p v-else class="text-sm -ml-3.5">Aucun dispositif dans ce groupement.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </md-content>
                                        </md-dialog>
                                    </template>
                                </div>
                                <md-divider class="mb-1 mt-0.5" v-if="index !== (monthHasIntervention(month.value).length - 1)"></md-divider>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <md-divider class="mb-1 mt-0.5" v-if="!(index === 5 || index === 11)"></md-divider>
        </div>
		<p class="mt-2"><span class="font-medium text-info">Total : </span>{{ interventionPlan.planning_intervention_previsions.length }} intervention(s)</p>
		<p><span class="font-medium text-info">Commentaire : </span>{{ interventionPlan.commentable ? interventionPlan.commentable.comment : 'Ø' }}</p>
    </div>
</template>

<script>
import dateTimeFormattingMixin from '@/mixins/date-time-formatting-mixin'
export default {
    name: "InterventionPlanCard",
    mixins: [ dateTimeFormattingMixin ],
    props: {
        interventionPlan: {
            type: Object,
            default() {
                return {
                    intervention_type: Object,
                    planning_intervention_previsions: Array
                }
            }
        },
        edit: {
            type: Boolean,
            default() {
                return false;
            }
        }
    },
    data() {
        return {
            months: [
                [
                    { value: 0, label: 'Janvier' },
                    { value: 6, label: 'Juillet' }
                ],
                [
                    { value: 1, label: 'Février' },
                    { value: 7, label: 'Août' }
                ],
                [
                    { value: 2, label: 'Mars' },
                    { value: 8, label: 'Septembre' }
                ],
                [
                    { value: 3, label: 'Avril' },
                    { value: 9, label: 'Octobre' }
                ],
                [
                    { value: 4, label: 'Mai' },
                    { value: 10, label: 'Novembre' }
                ],
                [
                    { value: 5, label: 'Juin' },
                    { value: 11, label: 'Décembre' }
                ]
            ],
            deviceGroupsModal: {
                active: false,
                data: {
                    previsionId: null,
                    deviceGroups: []
                }
            },
        }
    },
    methods: {
        openDeviceGroupsModal(interventionPrevision) {
            this.deviceGroupsModal.active = true
            this.deviceGroupsModal.data = {
                previsionId: interventionPrevision.id,
                deviceGroups: interventionPrevision.device_groups
            }
        },
        monthHasIntervention(month) {
            return this.interventionPlan.planning_intervention_previsions.filter(intervention => {
                return intervention.month === month && intervention.is_active
            })
        },
    }
}
</script>

<style scoped lang="scss">
.intervention-plan {
    &:first-child {
        padding-top: 0 !important;
    }
    &:last-child {
        padding-bottom: 0 !important;
    }
}
.md-layout-item.pl-0:first-child {
	padding-left: 0 !important;
}
</style>
